module.exports = __webpack_public_path__ + "static/media/Bag Sample Design_Side_1.873306ed.jpg";